import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=c8d68486&"
import script from "./Home.ts?vue&type=script&lang=ts&"
export * from "./Home.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports